import React from 'react';

import { StyledDayOfWeekButton } from './styled';

export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export type Day = (typeof days)[number];

export type DayOfWeekButtonProps = {
  active: boolean;
  day: Day;
  onClick: ({ day, event }: { day: Day; event: React.MouseEvent<HTMLButtonElement> }) => void;
};

export function DayOfWeekButton({ active, day, onClick }: DayOfWeekButtonProps) {
  return <StyledDayOfWeekButton $active={active} label={day} onClick={(event) => onClick({ day, event })} />;
}
